module.exports = __webpack_public_path__ + "static/media/lessons-from-a-fresh-entrepreneur.6edaf9b9.jpg";